<template>
   <el-popover
	 		placement="top-start" 
			title="Channel Change History" 
			trigger="hover"
			@show="getChannelChangeHistory()"
			>
			<div v-if="!onload">
				<div v-if="!_gHlp.isEmpty(listChilds)">
					<p v-for="item in listChilds" :key="item.customer_id">
							<b>{{ item.channel.name }} - {{item.platform.name}}</b><br/>
							<small>Old Customer Id {{ item.customer_id }} | Created At {{ _gHlp.formatDate(item.created_at) }}</small>
					</p>
				</div>
				<div v-else>
					<small><i>No History</i></small>
				</div>
			</div>
			<div v-else>
				<small><i>load content...</i></small>
			</div>
			<!-- <p slot="reference" class="mb-0 top-line">{{ channel_name }} <i class="fas fa-star text-warning"></i></p> -->
			<p slot="reference" class="mb-0 top-line"><i class="fas fa-star text-warning"></i></p>
	</el-popover>
</template>
<script>
	import { Popover } from 'element-ui'
	import { useCustomerStore } from '@/stores/customerStore'
	import { mapActions } from 'pinia'
  export default {
		props: ['customer_name','customer_contact_no','customer_created_at','channel_name'],
    name: 'channel-popover',
		components:{
			[Popover.name]: Popover
		},
    data() {
      return {
        listChilds: [],
				onload: false
      }
    },
		methods: {
        ...mapActions(useCustomerStore, ['getPrevCustomers']),
				async getChannelChangeHistory(){
					this.onload = true;
					this.listChilds = await this.getPrevCustomers(this.customer_contact_no,this.customer_created_at);
					console.log(this.listChilds);
					if(!_gHlp.isEmpty(this.listChilds)) this.listChilds.sort((a, b) => b.customer_id - a.customer_id)
					this.onload = false;
				}
		}

  }
</script>
